import { useBaseSWR } from './useBaseSWR';
import fetcherInstance from '../fetcherInstance';
import { ApiResponse } from '../../types/api';

const useInstanceSWR = <ApiData=any>(endpoint: string | null, swrOptions: any = {}) => {
  return useBaseSWR<ApiResponse<ApiData>>(endpoint, fetcherInstance, 'instance', swrOptions);
};

export default useInstanceSWR;
